export const SET_NEW_FORM_FIELDS = 'SET_NEW_FORM_FIELDS'
export const RESET_FORM_FIELDS = 'RESET_FORM_FIELDS'
export const SET_FORMS = 'SET_FORMS'
export const SET_ASSIGNED_FORMS = 'SET_ASSIGNED_FORMS'
export const SET_SUBMISSION = 'SET_SUBMISSION'
export const SET_USER_STORES = 'SET_USER_STORES'
export const SET_SELECTED_STATUS = 'SET_SELECTED_STATUS'
export const SET_SELECTED_LOCATION = 'SET_SELECTED_LOCATION'
export const SET_SELECTED_START_DATE = 'SET_SELECTED_START_DATE'
export const SET_SELECTED_END_DATE = 'SET_SELECTED_END_DATE'
export const SET_FILES = 'SET_FILES'

export const SET_CURRENT_ITEMS = 'SET_CURRENT_ITEMS'
export const SET_CURRENT_TOGGLE_ITEM_FUNCTION =
  'SET_CURRENT_TOGGLE_ITEM_FUNCTION'
export const SET_ASSIGN_SEARCH_VALUE = 'SET_ASSIGN_SEARCH_VALUE'
export const SET_CURRENT_HIDE_SELECTED_ITEMS_FUNCTION =
  'SET_CURRENT_HIDE_SELECTED_ITEMS_FUNCTION'
export const SET_CURRENT_SHOW_SELECTED_ITEMS_FUNCTION =
  'SET_CURRENT_SHOW_SELECTED_ITEMS_FUNCTION'
export const SET_CURRENT_SHOW_SELECTED_ITEMS = 'SET_CURRENT_SHOW_SELECTED_ITEMS'
export const RESET_SELECTED_ITEMS = 'RESET_SELECTED_ITEMS'
export const TOGGLE_MODAL = 'TOGGLE_MODAL'
export const SET_CURRENT_TAB = 'SET_CURRENT_TAB'
export const SET_CURRENT_SELECTED_ITEMS = 'SET_CURRENT_SELECTED_ITEMS'
export const SET_SHOW_SELECTED_ORG_GROUPS = 'SET_SHOW_SELECTED_ORG_GROUPS'
export const SET_SHOW_SELECTED_USERS = 'SET_SHOW_SELECTED_USERS'
export const SET_SHOW_SELECTED_LOCATION_GROUPS =
  'SET_SHOW_SELECTED_LOCATION_GROUPS'
export const SET_SHOW_SELECTED_STORES = 'SET_SHOW_SELECTED_STORES'
export const SET_SHOW_SELECTED_ROLES = 'SET_SHOW_SELECTED_ROLES'
export const SET_SELECTED_ORG_GROUPS = 'SET_SELECTED_ORG_GROUPS'
export const SET_SELECTED_USERS = 'SET_SELECTED_USERS'
export const SET_SELECTED_LOCATION_GROUPS = 'SET_SELECTED_LOCATION_GROUPS'
export const SET_SELECTED_LOCATIONS = 'SET_SELECTED_LOCATIONS'
export const SET_SELECTED_ROLES = 'SET_SELECTED_ROLES'
export const SET_SELECTED_STORES = 'SET_SELECTED_STORES'
export const SET_SHOW_SELECTED_LOCATIONS = 'SET_SHOW_SELECTED_LOCATIONS'
export const SET_SELECTED_ROLES_FILTER = 'SET_SELECTED_ROLES_FILTER'
export const SET_SHOW_SELECTED_USERS_ITEMS = 'SET_SHOW_SELECTED_USERS_ITEMS'
export const SET_SELECTED_ROLE_GROUPS = 'SET_SELECTED_ROLE_GROUPS'
export const SET_SHOW_FORM_SUBMISSION = 'SET_SHOW_FORM_SUBMISSION'
export const SET_FORM_SUBMISSION_ID = 'SET_FORM_SUBMISSION_ID'
export const SET_LOADING_FORMS = 'SET_LOADING_FORMS'
export const SET_SUBMISSION_MODAL_DATA = 'SET_SUBMISSION_MODAL_DATA'
export const SET_FORM_SECTIONS = 'SET_FORM_SECTIONS'
export const SET_FILL_FORM_MODAL_DATA = 'SET_FILL_FORM_MODAL_DATA'
